// ── Hair type image imports ──
import hair1A from '../../assets/logos/1A.png'
import hair1B from '../../assets/logos/1B.png'
import hair1C from '../../assets/logos/1C.png'
import hair2A from '../../assets/logos/2A.png'
import hair2B from '../../assets/logos/2B.png'
import hair2C from '../../assets/logos/2C.png'
import hair3A from '../../assets/logos/3A.png'
import hair3B from '../../assets/logos/3B.png'
import hair3C from '../../assets/logos/3C.png'
import hair4A from '../../assets/logos/4A.png'
import hair4B from '../../assets/logos/4B.png'
import hair4C from '../../assets/logos/4C.png'
export const NEW_USER_FLOW = [
  {
    id: 'store_owner',
    type: 'buttons',
    question: 'Are you a store owner?',
    saveKey: 'storeOwner',
    options: ['Yes', 'No'],
    validationApi: null,
    maxRetries: 0,
  },
  {
    id: 'referral_source',
    type: 'buttons',
    question: 'How did you hear about Halisi Cosmetics?',
    saveKey: 'referralSource',
    options: ['Social Media', 'Referral', 'Online Search'],
    validationApi: null,
    maxRetries: 0,
  },
  {
    id: 'contact_source',
    type: 'buttons',
    question: 'How would you like to be contacted?',
    saveKey: 'contactSource',
    options: ['Email', 'WhatsApp', 'SMS', 'Do not contact me'],
    validationApi: null,
    maxRetries: 0,
  },
  {
    id: 'phone_number',
    type: 'text',
    question:
      'Please enter your phone number, including the country code if applicable (for example, +33 6 12 34 56 78).',
    saveKey: 'phoneNumber',
    validationApi: null,
    maxRetries: 0,
    showWhen: {
      field: 'contactSource',
      equals: ['WhatsApp', 'SMS'],
    },
  },
  {
    id: 'self_or_child',
    type: 'buttons',
    question: 'Who are you shopping for?',
    saveKey: 'shoppingFor',
    options: ['Adult', 'Child'],
    validationApi: null,
    maxRetries: 0,
  },
  {
    id: 'demographics',
    type: 'text',
    questionTemplate: '{demographicsQuestion}',
    fallbackQuestion: 'What is your age, gender, and location?',
    saveKey: 'demographics',
    validationApi: 'ValidateDemographics',
    maxRetries: 3,
  },
  {
    id: 'hair_photo',
    type: 'camera',
    question:
      'Please take a photo of your hair or upload one. This helps us analyse your hair texture and condition for better recommendations.',
    saveKey: 'hairPhoto',
    validationApi: null,
    maxRetries: 0,
    backendAction: 'predictHairAttributes',
  },
  {
    id: 'hair_prediction_review',
    type: 'generated',
    questionTemplate:
      'Based on your currently visible hair in the photo, we predict your hair class is {predictedHairClass}. {predictedHairDescription}',
    fallbackQuestion:
      'Based on your currently visible hair in the photo, we have predicted your hair class. Please review it before continuing.',
    saveKey: null,
    validationApi: null,
    maxRetries: 3,
    autoAdvance: true,
  },
  {
    id: 'hair_prediction_confirm',
    type: 'buttons',
    question:
      'Does this predicted hair class look correct for your hair right now?',
    saveKey: 'isPredictedHairClassCorrect',
    options: ['Yes', 'No'],
    validationApi: null,
    maxRetries: 0,
  },
  {
    id: 'hair_prediction_corrected_value',
    type: 'picture',
    question:
      'No problem — please select your correct hair class from the options below.',
    saveKey: 'correctedHairClass',
    validationApi: null,
    maxRetries: 0,
    showWhen: {
      field: 'isPredictedHairClassCorrect',
      equals: 'No',
    },
    options: [
      {
        label: 'Fine, pin-straight hair ',
        value: '1A',
        image: hair1A,
      },
      {
        label: 'Straight hair with slight body ',
        value: '1B',
        image: hair1B,
      },
      {
        label: 'Coarse, straight, thick hair ',
        value: '1C',
        image: hair1C,
      },

      {
        label: 'Loose, barely-there waves ',
        value: '2A',
        image: hair2A,
      },
      {
        label: 'Defined S-shaped waves ',
        value: '2B',
        image: hair2B,
      },
      {
        label: 'Strong waves, near-curls ',
        value: '2C',
        image: hair2C,
      },
      {
        label: 'Large, loose spiral curls',
        value: '3A',
        image: hair3A,
      },
      {
        label: 'Bouncy, springy ringlet curls ',
        value: '3B',
        image: hair3B,
      },
      {
        label: 'Tight, dense corkscrew curls',
        value: '3C',
        image: hair3C,
      },
      {
        label: 'Defined, tight coily curls ',
        value: '4A',
        image: hair4A,
      },
      {
        label: 'Z-shaped, fluffy coils',
        value: '4B',
        image: hair4B,
      },
      {
        label: 'Very tight, densely packed coils',
        value: '4C',
        image: hair4C,
      },
    ],
  },
  {
    id: 'hair_profile',
    type: 'text',
    questionTemplate:
      'Thanks. We will use {finalHairClass} as your hair class. What best describes your current hair situation? For example: natural, braids, locs or chemically treated hair. Do you have any hair or scalp concerns, and what you’d like to achieve with your hair.',
    fallbackQuestion:
      'Now describe your main concerns, goals, scalp condition, and structure (natural, braids, locks, extensions).',
    saveKey: 'hairProfile',
    validationApi: 'ValidateHairProfile',
    maxRetries: 3,
  },
  {
    id: 'routine_preferences',
    type: 'text',
    question:
      'That’s great. Now walk me through your current hair routine. You can include what products you use and at what frequency. Also, whats your monthly budget usually.',
    saveKey: 'routinePreferences',
    validationApi: 'ValidateRoutinePreferences',
    maxRetries: 3,
  },
  {
    id: 'medical_lifestyle',
    type: 'text',
    questionTemplate:
      'A few quick things to help us personalize your routine — do you have any allergies or scalp sensitivities? Or {medicalContextPhrase} should know about? Which lifestyle factors impact your hair e.g factors like stress, diet, or climate ?',
    saveKey: 'medicalLifestyle',
    validationApi: 'ValidateMedicalLifestyle',
    maxRetries: 3,
  },
  {
    id: 'diagnosis',
    type: 'generated',
    questionTemplate:
      'Thanks {firstName}. I now have enough information to generate your hair profile and diagnosis.',
    fallbackQuestion:
      'Thanks. I now have enough information to generate your hair profile and diagnosis.',
    saveKey: null,
    validationApi: null,
    maxRetries: 0,
    backendAction: 'generateDiagnosis',
  },
  {
    id: 'recommendations',
    type: 'result',
    questionTemplate:
      'Great news{firstNamePrefix}! Based on your {hairType} hair profile and needs, here are your top 3 picks. Swipe to explore.',
    fallbackQuestion:
      'Great news! Based on your hair profile and needs, here are your top 3 picks. Swipe to explore.',
    saveKey: 'recommendations',
    validationApi: null,
    maxRetries: 0,
    backendAction: 'generateRecommendations',
  },
  // {
  //   id: 'eco_routine',
  //   type: 'result',
  //   questionTemplate:
  //     'Here is your personalized routine{ecoPreferenceSuffix}, including eco-conscious options where relevant.',
  //   fallbackQuestion:
  //     'Here is your personalized routine, including eco-conscious options where relevant.',
  //   saveKey: 'ecoRoutine',
  //   validationApi: null,
  //   maxRetries: 0,
  //   backendAction: 'generateEcoRoutine',
  // },
]

const existingUserBranchStep = (stepId, action, overrides = {}) => {
  const step = NEW_USER_FLOW.find(
    (question) => question.id === stepId,
  )

  return {
    ...step,
    ...overrides,

    // If this particular reused step supplies its own
    // showWhen rule, preserve it.
    showWhen:
      overrides.showWhen || {
        field: 'existingUserAction',
        equals: action,
      },
  }
}

export const EXISTING_USER_FLOW = [
  // =====================================================
  // EXISTING USER MAIN MENU
  // =====================================================

  {
    id: 'last_visit_summary',
    type: 'buttons',
    question:
      'Last time, your main focus was {hairGoals}, while working on {hairChallenges} and {scalpChallenges}. Your last hair analysis identified your hair as {hairClass}. What would you like to do today?',
    saveKey: 'existingUserAction',
    options: [
      {
        value: 'option_update_profile',
        label: 'Something has changed with my hair',
      },
      {
        value: 'option_new_product',
        label: 'Find me a new product',
      },
      {
        value: 'option_restart_analysis',
        label: 'Start my hair analysis again',
      },
      {
        value: 'option_someone_else',
        label: 'Do this for someone else',
      },
    ],
    validationApi: null,
    maxRetries: 0,
  },

  // =====================================================
  // FLOW 1
  // SOMETHING HAS CHANGED WITH MY HAIR
  // =====================================================

  {
    id: 'update_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,
    showWhen: {
      field: 'existingUserAction',
      equals: 'option_update_profile',
    },
  },

  // =====================================================
  // FLOW 2
  // FIND ME A NEW PRODUCT
  // =====================================================

  {
    id: 'new_product_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,
    showWhen: {
      field: 'existingUserAction',
      equals: 'option_new_product',
    },
  },

  {
    id: 'new_product_profile_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,
    showWhen: {
      field: 'existingUserAction',
      equals: 'option_new_product',
    },
  },

  {
  id: 'profile_confirm_question',
  type: 'buttons',
  questionTemplate: '{profileConfirmQuestion}',
  fallbackQuestion: 'Does this information still look correct?',
  saveKey: 'profileConfirmation',
  showWhen: {
      field: 'existingUserAction',
      equals: 'option_new_product',
    },
  options: [
    {
      value: 'Yes',
      label: 'Yes, use this profile',
    },
    {
      value: 'No',
      label: 'No, I need to update something',
    },
  ],
  },

  {
    id: 'profile_confirmed',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,

    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_new_product',
        },
        {
          field: 'profileConfirmation',
          equals: 'Yes',
        },
      ],
    },
  },

  {
    id: 'profile_update_prompt',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,

    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_new_product',
        },
        {
          field: 'profileConfirmation',
          equals: 'No',
        },
      ],
    },
  },

  // =====================================================
  // SHARED PROFILE-REFRESH QUESTIONS
  //
  // Used by:
  // 1. Something changed with my hair
  // 2. Find me a new product -> No, profile is not correct
  // =====================================================

  {
    id: 'update_hair_profile',
    type: 'text',
    questionTemplate: '{updateHairProfileQuestion}',
    fallbackQuestion: 'Let’s refresh your hair profile. Since your last visit, has anything changed with your current hair situation — for example whether your hair is natural, braided, in locs or chemically treated? Tell me about any hair or scalp concerns you’re experiencing now, and what you’d currently like to achieve with your hair.',
    saveKey: 'hairProfile',
    validationApi: 'ValidateHairProfile',
    maxRetries: 3,
    showWhen: {
      any: [
        {
          field: 'existingUserAction',
          equals: 'option_update_profile',
        },
        {
          all: [
            {
              field: 'existingUserAction',
              equals: 'option_new_product',
            },
            {
              field: 'profileConfirmation',
              equals: 'No',
            },
          ],
        },
      ],
    },
  },

  {
    id: 'update_routine_preferences',
    type: 'text',
  questionTemplate: '{updateRoutineQuestion}',
  fallbackQuestion:
    'Now let’s check in on your routine. Are you still following the same hair routine as last time? Tell me what products you’re currently using, how often you use them, and whether your usual monthly budget has changed.',    saveKey: 'routinePreferences',
    validationApi: 'ValidateRoutinePreferences',
    maxRetries: 3,
    showWhen: {
      any: [
        {
          field: 'existingUserAction',
          equals: 'option_update_profile',
        },
        {
          all: [
            {
              field: 'existingUserAction',
              equals: 'option_new_product',
            },
            {
              field: 'profileConfirmation',
              equals: 'No',
            },
          ],
        },
      ],
    },
  },

  {
    id: 'update_medical_lifestyle',
    type: 'text',
    questionTemplate: '{updateMedicalLifestyleQuestion}',
    fallbackQuestion:
      'And one quick health and lifestyle check-in. Since your last visit, has anything changed with your allergies or scalp sensitivities, medical conditions, medications or treatments, or pregnancy/postpartum information? You can also tell me if lifestyle factors such as stress, diet or climate are affecting your hair differently now.',
        saveKey: 'medicalLifestyle',
    validationApi: 'ValidateMedicalLifestyle',
    maxRetries: 3,
    showWhen: {
      any: [
        {
          field: 'existingUserAction',
          equals: 'option_update_profile',
        },
        {
          all: [
            {
              field: 'existingUserAction',
              equals: 'option_new_product',
            },
            {
              field: 'profileConfirmation',
              equals: 'No',
            },
          ],
        },
      ],
    },
  },

  // Only Flow 1 gets this particular completion message.
  {
    id: 'update_complete',
    type: 'text',
    saveKey: null,
    autoAdvance: true,

    questionTemplate: '{updateCompleteMessage}',

    fallbackQuestion:
      'Thanks — I’ve refreshed your information. Let’s use your updated profile to continue with your hair analysis and recommendations.',
        validationApi: null,
    maxRetries: 0,

    showWhen: {
      field: 'existingUserAction',
      equals: 'option_update_profile',
    },
  },

  // Flow 2 YES skips the refresh questions and reaches this.
  {
    id: 'new_product_recommendations',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,
    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_new_product',
        },
        {
          field: 'profileConfirmation',
          equals: 'Yes',
        },
      ],
    },
  },

  // =====================================================
  // FLOW 3
  // START MY HAIR ANALYSIS AGAIN
  // =====================================================

  {
    id: 'restart_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,

    showWhen: {
      field: 'existingUserAction',
      equals: 'option_restart_analysis',
    },
  },

  // Reuse original NEW_USER_FLOW camera question.
  existingUserBranchStep(
    'hair_photo',
    'option_restart_analysis',
  ),

  // Reuse original prediction.
  existingUserBranchStep(
    'hair_prediction_review',
    'option_restart_analysis',
  ),

  existingUserBranchStep(
    'hair_prediction_confirm',
    'option_restart_analysis',
  ),

  // Reuse manual correction only if prediction is rejected.
  {
    ...NEW_USER_FLOW.find(
      (question) =>
        question.id === 'hair_prediction_corrected_value',
    ),

    id: 'hair_prediction_corrected_value',
    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_restart_analysis',
        },
        {
          field: 'isPredictedHairClassCorrect',
          equals: 'No',
        },
      ],
    },
  },

  // Continue exactly like original new-user flow.
  existingUserBranchStep(
    'hair_profile',
    'option_restart_analysis',
  ),

  existingUserBranchStep(
    'routine_preferences',
    'option_restart_analysis',
  ),

  existingUserBranchStep(
    'medical_lifestyle',
    'option_restart_analysis',
  ),

  // =====================================================
  // FLOW 4
  // DO THIS FOR SOMEONE ELSE
  //
  // IMPORTANT:
  // Same APIs / validators as NEW_USER_FLOW.
  // Only the conversational language is changed to
  // third person.
  // =====================================================

  {
    id: 'someone_else_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,

    showWhen: {
      field: 'existingUserAction',
      equals: 'option_someone_else',
    },
  },

  {
    id: 'analysis_recipient',
    type: 'buttons',

    questionTemplate: '{analysisRecipientQuestion}',
    fallbackQuestion: 'Who are we doing the analysis for?',

    saveKey: 'analysisRecipient',

    options: ['Adult', 'Child'],

    validationApi: null,
    maxRetries: 0,

    showWhen: {
      field: 'existingUserAction',
      equals: 'option_someone_else',
    },
  },

  {
    id: 'someone_else_adult_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,

    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_someone_else',
        },
        {
          field: 'analysisRecipient',
          equals: 'Adult',
        },
      ],
    },
  },

  {
    id: 'someone_else_child_intro',
    type: 'generated',
    saveKey: null,
    autoAdvance: true,

    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_someone_else',
        },
        {
          field: 'analysisRecipient',
          equals: 'Child',
        },
      ],
    },
  },

  // -----------------------------------------------------
  // GUEST DEMOGRAPHICS
  // Still uses ValidateDemographics
  // -----------------------------------------------------

  existingUserBranchStep(
    'demographics',
    'option_someone_else',
    {
      id: 'someone_else_demographics',
      questionTemplate: '{someoneElseDemographicsQuestion}',
      fallbackQuestion:
        'To help us personalise the analysis, what is their age, gender, and location?',    },
  ),

  // -----------------------------------------------------
  // GUEST PHOTO
  // Same camera + prediction backend.
  // Third-person wording only.
  // -----------------------------------------------------

  existingUserBranchStep(
    'hair_photo',
    'option_someone_else',
    {
      id: 'someone_else_hair_photo',

    questionTemplate: '{someoneElseHairPhotoQuestion}',

    fallbackQuestion:
      'Please take a photo of their hair or upload one. This helps us analyse their hair texture and condition for more relevant recommendations.',    },
  ),

  // -----------------------------------------------------
  // GUEST HAIR PREDICTION
  // -----------------------------------------------------

  existingUserBranchStep(
    'hair_prediction_review',
    'option_someone_else',
    {
      id: 'someone_else_hair_prediction_review',

      questionTemplate: '{someoneElsePredictionReviewQuestion}',

      fallbackQuestion:
        'Based on the hair visible in the photo, we predict their hair class is {predictedHairClass}. {predictedHairDescription}',   },
        ),

  existingUserBranchStep(
    'hair_prediction_confirm',
    'option_someone_else',
    {
      id: 'someone_else_hair_prediction_confirm',

      questionTemplate: '{someoneElsePredictionConfirmQuestion}',

      fallbackQuestion:
        'Does this predicted hair class look correct for their hair right now?',    },
  ),

  // Manual correction for guest prediction.
  {
    ...NEW_USER_FLOW.find(
      (question) =>
        question.id === 'hair_prediction_corrected_value',
    ),

    id: 'someone_else_hair_prediction_corrected_value',

    questionTemplate: '{someoneElseCorrectHairClassQuestion}',

    fallbackQuestion:
      'No problem — please select their correct hair class from the options below.',
    showWhen: {
      all: [
        {
          field: 'existingUserAction',
          equals: 'option_someone_else',
        },
        {
          field: 'isPredictedHairClassCorrect',
          equals: 'No',
        },
      ],
    },
  },

  // -----------------------------------------------------
  // GUEST HAIR PROFILE
  //
  // SAME:
  // saveKey: hairProfile
  // validationApi: ValidateHairProfile
  //
  // ONLY wording changes.
  // -----------------------------------------------------

  existingUserBranchStep(
    'hair_profile',
    'option_someone_else',
    {
      id: 'someone_else_hair_profile',

      questionTemplate: '{someoneElseHairProfileQuestion}',

      fallbackQuestion:
        'Thanks. We will use {finalHairClass} as their hair class. What best describes their current hair situation? For example: natural, braids, locs or chemically treated hair. Do they have any hair or scalp concerns, and what would they like to achieve with their hair?',    },
  ),

  // -----------------------------------------------------
  // GUEST ROUTINE
  //
  // SAME:
  // saveKey: routinePreferences
  // validationApi: ValidateRoutinePreferences
  // -----------------------------------------------------

  existingUserBranchStep(
    'routine_preferences',
    'option_someone_else',
    {
      id: 'someone_else_routine_preferences',

      questionTemplate: '{someoneElseRoutineQuestion}',

      fallbackQuestion:
        'Great. Now tell me about their current hair routine. What products do they use, how often do they use them, and what is their usual monthly budget for hair care?',    },
  ),

  // -----------------------------------------------------
  // GUEST MEDICAL / LIFESTYLE — ADULT
  //
  // SAME validator.
  // Third-person wording.
  // -----------------------------------------------------

  existingUserBranchStep(
    'medical_lifestyle',
    'option_someone_else',
    {
      id: 'someone_else_adult_medical_lifestyle',

      questionTemplate: '{someoneElseMedicalLifestyleQuestion}',

      fallbackQuestion:
        'A few quick things to help us personalise their recommendations — do they have any allergies or scalp sensitivities, medical conditions, medications or treatments we should know about? Are there any lifestyle factors such as stress, diet or climate that affect their hair?',
      showWhen: {
        all: [
          {
            field: 'existingUserAction',
            equals: 'option_someone_else',
          },
          {
            field: 'analysisRecipient',
            equals: 'Adult',
          },
        ],
      },
    },
  ),

  // -----------------------------------------------------
  // GUEST MEDICAL / LIFESTYLE — CHILD
  //
  // Don't ask pregnancy/postpartum questions for child.
  // Still uses the same validator.
  // -----------------------------------------------------

  existingUserBranchStep(
    'medical_lifestyle',
    'option_someone_else',
    {
      id: 'someone_else_child_medical_lifestyle',
      questionTemplate: '{someoneElseChildMedicalLifestyleQuestion}',
      fallbackQuestion:
        'A few quick things to help us personalise the child’s recommendations — do they have any allergies or scalp sensitivities, medical conditions, medications or treatments we should know about? You can also mention factors such as diet, climate, swimming, protective styles or anything else that may be affecting their hair or scalp.',      showWhen: {
        all: [
          {
            field: 'existingUserAction',
            equals: 'option_someone_else',
          },
          {
            field: 'analysisRecipient',
            equals: 'Child',
          },
        ],
      },
    },
  ),
]

export const CHAT_FLOWS = {
  newUser: NEW_USER_FLOW,
  existingUser: EXISTING_USER_FLOW,
}